import React, { Component } from "react";
import axios from "axios";
import { Card, Grid } from "@mui/material";
import { Link, Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

export default class Exams extends Component {
  state = {
    allExams: [],
    message: "",
    notification: false,
    noticolor: "success",
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    per_page: 20,
    page_no: 1,
    redirect: false,
  };

  componentDidMount() {
    this.getAllExams(this.state.page_no, this.state.per_page);
  }

  getAllExams = (page = 1, limit = this.state.per_page) => {
    if (init() === "success") {
      axios
        .get(`${Constants.getUrls.getAllExams}?page=${page}&limit=${limit}`)
        .then((resp) => {
          if (resp?.data?.status === "success") {
            this.setState({
              allExams: resp?.data?.data?.docs || [],
              pagination: resp?.data?.data || this.state.pagination,
              page_no: resp?.data?.data?.page || 1,
              notification: true,
              noticolor: "success",
              message: resp?.data?.message || "Exam list loaded.",
            });
          } else {
            this.setState({
              notification: true,
              noticolor: "error",
              message: resp?.data?.message || "Unable to load exams.",
            });
          }

          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err?.response?.data?.message || "Error fetching exams",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllExams(1, newLimit);
    });
  };

  handlePageChange = (newPage) => {
    this.getAllExams(newPage, this.state.per_page);
  };

  handleDelete = (id) => {
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteExam + id)
        .then((resp) => {
          this.setState({
            notification: true,
            noticolor: resp?.data?.status === "success" ? "success" : "error",
            message: resp?.data?.message || "Exam deleted.",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" }, () => {
              this.getAllExams(this.state.page_no, this.state.per_page);
            });
          }, 2500);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err?.response?.data?.message || "Unable to delete exam.",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/signin" replace />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Exam List
              </MDTypography>
            </MDBox>
            <Grid item sm={4} px={2} py={2} align="right">
              <Link to="/addexam">
                <MDButton variant="contained" size="small" color="primary">
                  Create Exam
                </MDButton>
              </Link>
            </Grid>
            <MDBox>
              <DataTable
                table={{
                  columns: [
                    { Header: "serial", accessor: "serial", width: "6%" },
                    { Header: "Exam", accessor: "name" },
                    { Header: "Image", accessor: "image" },
                    { Header: "Status", accessor: "status" },
                    { Header: "Action", accessor: "action" },
                  ],
                  rows: this.state.allExams.map((exam, index) => ({
                    serial: index + 1,
                    name: exam?.exam_name || "-",
                    image: exam?.exam_image ? (
                      <img
                        src={`${Constants.imageDomain}${exam.exam_image}`}
                        alt={exam.exam_name || "Exam"}
                        style={{
                          width: "72px",
                          height: "72px",
                          objectFit: "cover",
                          borderRadius: "12px",
                          border: "1px solid rgba(148,163,184,0.25)",
                        }}
                      />
                    ) : (
                      <span>-</span>
                    ),
                    status: (
                      <span
                        style={{
                          color: exam?.status === "active" ? "#16a34a" : "#f59e0b",
                          fontWeight: 700,
                          textTransform: "capitalize",
                        }}
                      >
                        {exam?.status || "inactive"}
                      </span>
                    ),
                    action: (
                      <>
                        <div>
                          <Link to={`/updateexam/${exam._id}`}>
                            <MDButton variant="outlined" size="small" color="success">
                              Update
                            </MDButton>
                          </Link>
                        </div>
                        <div style={{ marginTop: "1rem" }}>
                          <MDButton
                            variant="outlined"
                            size="small"
                            color="error"
                            onClick={() => this.handleDelete(exam._id)}
                          >
                            Delete
                          </MDButton>
                        </div>
                      </>
                    ),
                  })),
                }}
                entriesPerPage={{ defaultValue: this.state.per_page, entries: [10, 25, 50, 100] }}
                page_no={this.state.pagination?.page}
                totalPages={this.state.pagination?.totalPages}
                hasNextPage={this.state.pagination?.hasNextPage}
                hasPrevPage={this.state.pagination?.hasPrevPage}
                isnextPage={this.state.pagination?.nextPage}
                prevPage={this.state.pagination?.prevPage}
                totalDocs={this.state.pagination?.totalDocs}
                onPageChange={this.handlePageChange}
                onEntriesPerPageChange={this.handleEntriesPerPageChange}
              />
            </MDBox>

            <MDSnackbar
              color={this.state.noticolor}
              icon="notifications"
              title="AgriQuiz"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
